import * as actions from '../actions/actionTypes'
import { ITranslationsState, IState } from '../store/state';

const translations = (state : ITranslationsState = { translations: {} }, action:any) : ITranslationsState => {
  switch (action.type) {
    case actions.FETCH_TRANSLATIONS_SUCCEEDED:
      return Object.assign({}, state, action.data)
    default:
      return state
  }
}

// fetch translation tags and their according translation
/*
  returns an object containing all translation tag names (property) and the according translation (string)
    property: string
*/
export const getTranslations = (state:IState) : { [key:string]: string } => {
  if (!Object.keys(state.translations).length) {
    return {}
  }
  return state.translations.translations
}

export default translations
